import React from 'react';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';
import request from '../../helpers/request';
import setViewTitle from '../../helpers/setViewTitle';
import SimplePage from '../common/SimplePage';
import stocktakingConfig from './config/stocktakingConfig';
import moment from 'moment';

var StocktakingList = createReactClass({
  getInitialState() {
    return {
      stocktakings: []
    };
  },

  componentWillMount() {
    setViewTitle('Inventur');
  },

  componentDidMount() {
    request.get({
      url: stocktakingConfig.listUrl,
      success: data => {
        if (this.isMounted()) {
          this.setState({
            stocktakings: data
          });
        }
      }
    });
  },

  render() {

    var stocktakingList = this.state.stocktakings.map(s => {
      let createdDate = moment(s.createdDate).format('DD.MM.YYYY HH:mm');
      let confirmedDate = s.confirmedDate ? moment(s.confirmedDate).format('DD.MM.YYYY HH:mm') : '';
      let completedDate = s.completedDate ? moment(s.completedDate).format('DD.MM.YYYY HH:mm') : '';

      return (
        <tr key={s.id}>
          <td><Link to={`/stocktaking/${s.id}`}>{s.storageLocation}</Link></td>
          <td>{createdDate}</td>
          <td>{confirmedDate}</td>
          <td>{completedDate}</td>
          <td>{s.user}</td>
        </tr>
      );
    });

    return (
      <SimplePage title="Inventur" icon="pencil">
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Lagerort</th>
                <th>Gestartet am</th>
                <th>Eingemeldet am</th>
                <th>Übernommen am</th>
                <th>Benutzer</th>
              </tr>
            </thead>
            <tbody>
              {stocktakingList}
            </tbody>
          </table>
        </div>
      </SimplePage>
    );
  }
});

export default StocktakingList;



// WEBPACK FOOTER //
// ./src/components/stocktaking/StocktakingList.js